import React, { useCallback, useEffect, useRef, useState } from 'react';
import { megaMenuListsPropTypes } from './MegaMenuListsPropTypes';
import { BREAKPOINTS } from '@Theme/natucare/constants/breakpoints';
import { DEVICE_TYPES } from '@Theme/natucare/constants/deviceTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Picture from '@Theme/natucare/components/Picture/Picture';
import { useDeviceDetect } from '@App/common/hooks/useDeviceDetect';
import * as styles from './MegaMenuLists.module.scss';
const MegaMenuLists = ({
  items,
  handleNestedStateChange
}) => {
  if (!items) {
    return null;
  }
  const rootColRefs = useRef([]);
  const {
    deviceType
  } = useDeviceDetect(BREAKPOINTS);
  const isDesktop = deviceType !== DEVICE_TYPES[BREAKPOINTS.XS] && deviceType !== DEVICE_TYPES[BREAKPOINTS.SM] && deviceType !== DEVICE_TYPES[BREAKPOINTS.MD];
  const {
    0: nestedNavItemOpenedIndex,
    1: setNestedNavItemOpenedIndex
  } = useState(-1);
  const handleNestedNavClick = useCallback(index => {
    if (isDesktop) {
      return;
    }
    setNestedNavItemOpenedIndex(prevState => {
      const isOpen = prevState !== index;
      return isOpen ? index : -1;
    });
  }, [deviceType]);
  useEffect(() => {
    if (handleNestedStateChange) {
      handleNestedStateChange(nestedNavItemOpenedIndex !== -1);
    }
  }, [nestedNavItemOpenedIndex, handleNestedStateChange]);
  useEffect(() => {
    if (nestedNavItemOpenedIndex !== -1 && rootColRefs.current[nestedNavItemOpenedIndex]) {
      rootColRefs.current[nestedNavItemOpenedIndex].scrollTop = 0;
    }
  }, [nestedNavItemOpenedIndex]);
  const handleStopPropagation = e => {
    const navLabel = e.target.closest(`.${styles.rootLabel}`);
    if (!navLabel) {
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    onClick: handleStopPropagation
  }, items.map((item, index) => {
    const isListWithTiles = item.links.some(link => link.picture);
    return /*#__PURE__*/React.createElement("div", {
      ref: ref => rootColRefs.current[index] = ref,
      className: `
              ${styles.rootCol}
              ${isListWithTiles ? styles.rootColWithTiles : ''} 
              ${nestedNavItemOpenedIndex === index ? styles.rootColMobileOpened : ''}
            `,
      key: index
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.rootLabel,
      onClick: handleNestedNavClick.bind(this, index)
    }, item.label, /*#__PURE__*/React.createElement(Icon, {
      classname: styles.rootLabelIcon,
      size: {
        width: 8,
        height: 14
      },
      name: "arrowNav"
    })), /*#__PURE__*/React.createElement("ul", {
      className: styles.rootList
    }, item.links.map((link, linkIndex) => {
      var _link$picture, _link$picture2;
      const pictureData = {
        xs: {
          src: (_link$picture = link.picture) === null || _link$picture === void 0 ? void 0 : _link$picture.src
        },
        alt: (_link$picture2 = link.picture) === null || _link$picture2 === void 0 ? void 0 : _link$picture2.alt
      };
      return /*#__PURE__*/React.createElement("li", {
        className: `${styles.rootListItem} ${isListWithTiles ? styles.rootListItemTile : ''}`,
        key: linkIndex
      }, /*#__PURE__*/React.createElement("a", {
        href: link.href,
        className: styles.rootListItemLink
      }, isListWithTiles && link.picture && /*#__PURE__*/React.createElement(Picture, Object.assign({}, pictureData, {
        pictureClassname: styles.rootListItemPicture,
        imgClassname: styles.rootListItemImage
      })), link.label));
    })));
  }));
};
export default MegaMenuLists;